import { render } from "./QVPExamRegistration.vue?vue&type=template&id=b08b7e4e&scoped=true"
import script from "./QVPExamRegistration.vue?vue&type=script&lang=js"
export * from "./QVPExamRegistration.vue?vue&type=script&lang=js"

import "./QVPExamRegistration.vue?vue&type=style&index=0&id=b08b7e4e&scoped=true&lang=css"
import "./QVPExamRegistration.vue?vue&type=style&index=1&id=b08b7e4e&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b08b7e4e"]])

export default __exports__